import {CategoryType} from "@api";

import CategoriesServiceSingleton from "services/categories/CategoriesService";
import CategoryModel from "models/categories/Category";

type GetPostulateTopCategoriesTranslations = {
    topSectors: [string, number][];
    topRegions: [string, number][];
    topLanguages: [string, number][];
};

export const getPostulateTopCategoriesTranslations = ({
    topRegions,
    topSectors,
                                                          topLanguages
                                                }: GetPostulateTopCategoriesTranslations) => {
    const categoriesList = CategoriesServiceSingleton.getList();

    const topRegionsWithCategory = topRegions.map(([region, counter]) => {
        const regionCategory = categoriesList.filterByKeyAndCategoryType([region], CategoryType.REGION) as CategoryModel[];

        return [
            regionCategory[0],
            counter
        ] as [CategoryModel, number]
    });

    const topSectorsWithCategory = topSectors.map(([sector, counter]) => {
        const sectorCategory = categoriesList.filterByKeyAndCategoryType([sector], CategoryType.SECTOR) as CategoryModel[];

        return [
            sectorCategory[0],
            counter
        ] as [CategoryModel, number]
    });

    const topLanguagesWithCategory = topLanguages.map(([language, counter]) => {
        const languageCategory = categoriesList.filterByKeyAndCategoryType([language], CategoryType.LANGUAGES) as CategoryModel[];

        return [
            languageCategory[0],
            counter
        ] as [CategoryModel, number]
    });

    return {
        topRegionsWithCategory,
        topSectorsWithCategory,
        topLanguagesWithCategory
    }
}
